import React, { useState, useEffect } from 'react';
import moment from 'moment';
import ClickSelectText from '../ClickSelectText';
import EditorActions from '../../actions/editor';
import classnames from 'classnames';
import useDocumentClick from '../../utils/useDocumentClick';

import { connect } from 'react-redux';

import '../../../css/user.less';

const changeTenantButton = React.createRef();
const dropDownRef = React.createRef();

export const Tenant = ({ currentTenant, currentUser }) => {

    const [isOpen, toggleDropdown] = useState(false);

    const { isSso } = currentUser;

    useDocumentClick(dropDownRef, () => toggleDropdown(false));

    useEffect(() => {
        if (isOpen && !isSso) {
            changeTenantButton.current.focus();
        }
    }, [isOpen]);

    const onChangeTenantClick = () => {
        toggleDropdown(false);
        EditorActions.openTenantSelector();
    };

    const classes = classnames({
        'dropdown-box': true,
        'is-open': isOpen,
    });

    return (
        <div ref={dropDownRef} className={classes}>
            <button className="dropdown-btn" onClick={() => toggleDropdown(!isOpen)}>
                <div className="header-dropdown">
                    <span className="user-dropdown-text">{currentUser.tenantName}</span>
                    &nbsp;
                    <span className="glyphicon glyphicon-triangle-bottom" aria-hidden="true" />
                    {isSso ? <span className="label label-info">SSO</span> : null}
                </div>
            </button>
            <div className="dropdown-list-wrapper">
                <div className="user-dropdown-content">
                    <ClickSelectText text={currentUser.tenantName} />
                    {
                        currentTenant && currentTenant.organization 
                            ? <p className="list-group-item-text margin-top-small">{currentTenant.organization.name}</p>
                            : null
                    }
                    <p className="user-tenant-id quiet">
                        <ClickSelectText text={currentUser.tenantId} />
                    </p>
                    {
                        currentTenant && currentTenant.expiresAt !== null
                            ? (
                                <p className="list-group-item-text quiet margin-top-small">
                                    {
                                        `Tenant expires: ${moment(currentTenant.expiresAt).format('lll')}`
                                    }
                                </p>
                            )
                            : null
                    }
                    {isSso ? null : (
                        <>
                            <hr />
                            <ul className="list-unstyled user-options">
                                <li>
                                    <button className="btn btn-info" ref={changeTenantButton} onClick={onChangeTenantClick}>
                                        Change Tenant
                                    </button>
                                </li>
                            </ul>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = ({ currentTenant, currentUser }) => ({ currentTenant, currentUser });

export default connect(
    mapStateToProps,
)(Tenant);
